var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBkgAzzurro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1480 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3456.63,
    y1: 1174.18,
    x2: 2716.89,
    y2: 470.88,
    gradientTransform: "translate(4033.77 1526) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c91cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3f88c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1557a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 4189.21,
    y1: 1696.11,
    x2: 3212.36,
    y2: 810.39,
    gradientTransform: "translate(4033.77 1526) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c91cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3f88c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1557a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 4113.2,
    y1: 1854.78,
    x2: 2915.1,
    y2: 768.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 3456.71,
    y1: 1733.26,
    x2: 2313.26,
    y2: 380.24,
    gradientTransform: "translate(4033.77 1526) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c91cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#458cc8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3f88c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#2d73b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#1b5ea8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1557a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 3468.06,
    y1: 1537.26,
    x2: 2339.31,
    y2: 435.33,
    gradientTransform: "translate(4033.77 1526) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63a4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3f88c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1557a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 3323.53,
    y1: 1935.16,
    x2: 2505.12,
    y2: 968.17,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 4246.4,
    y1: 1711.03,
    x2: 3179.67,
    y2: 913.72,
    gradientTransform: "translate(4033.77 1526) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c91cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#3f88c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1557a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 4960.68,
    y1: 1368.92,
    x2: 2969.46,
    y2: 1067.69,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 3166.81,
    y1: 710.77,
    x2: 3895.99,
    y2: 1523.81,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 4354.2,
    y1: 1655.82,
    x2: 2742.21,
    y2: 944.23,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 3292.33,
    y1: 1000.99,
    x2: 3878.81,
    y2: 1480.84,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 4019.61,
    y1: 1605.47,
    x2: 3100.85,
    y2: 991.76,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 4180.89,
    y1: 2130.27,
    x2: 3475.8,
    y2: 1141.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 3252.26,
    cy: 987.99,
    fx: 3252.26,
    fy: 987.99,
    r: 1062.84,
    gradientTransform: "translate(4033.77 1305.25) rotate(-180) scale(1 1.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c91cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#3f88c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1557a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 4109.45,
    y1: 1983.99,
    x2: 3356.43,
    y2: 1092.96,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 3091.13,
    y1: 1632.06,
    x2: 2623.1,
    y2: 1049.46,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 3330.64,
    y1: 903.37,
    x2: 3860.12,
    y2: 1519.88,
    gradientTransform: "translate(4033.77 1526) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63a4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#3f88c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1557a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 3437.11,
    y1: 1111.01,
    x2: 3622.27,
    y2: 1296.18,
    gradientTransform: "translate(4033.77 1526) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63a4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#3f88c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3a82c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#2c72b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1557a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1557a3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1287.58,
    y1: 735.04,
    x2: 1584.14,
    y2: 887.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1557a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1557a3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 744.75,
    y1: 1042.21,
    x2: 744.75,
    y2: 729.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006fb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006fb6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 375.34,
    y1: -719.05,
    x2: 375.34,
    y2: -1242.89,
    gradientTransform: "translate(0 -738.95) scale(1 -1)",
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Sfumatura_senza_nome_5",
    x1: 0,
    y1: 500,
    x2: 1480,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006fb6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#006fb6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#006fb6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006fb6"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.14,
    y: -23.83,
    width: 1496.9,
    height: 1069.18,
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191.96-23.83H-3.39v1067.01h361.52c101.81-53.52,201.71-119.83,296.73-198.76,298.27-247.76,485.22-567.22,537.09-868.26Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.84-24.88H-5.81v883.65c163.02,8.32,338.13-3.74,517.59-38.94,424.25-83.22,778.02-277.15,980.06-509.53V-24.88Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.77,1045.36h528.99V81.25c-16.48-1.27-32.95-2.55-49.4-3.83-96.96-7.16-194.94-15.71-291.71-21.82,3.22,31.97,6.79,63.88,10.28,95.78,3.33,28.23,6.6,56.51,9.56,84.86,21.29,182.27,21.29,371.67-51.29,543.96-39.91,96.03-96.8,181.5-156.43,265.16Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.96,1045.36h410.8V343.14c-119.53-134.27-270.95-177.57-270.95-177.57,0,0,19.35,36.66,29.03,195.51,9.68,158.85,2.42,261.49-48.38,439.9-20.87,73.3-69.94,163.52-120.49,244.38Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.85,77.42c-96.96-7.16-194.94-15.71-291.71-21.82,3.23,31.97,6.79,63.88,10.28,95.78,3.32,28.23,6.6,56.51,9.55,84.86,12.9,110.43,17.97,223.48,3.84,333.76,126.98-76.95,234.31-165.14,316.52-259.69V81.18c-16.18-1.24-32.34-2.5-48.48-3.76Z",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.04,819.83c82.24-16.13,161.82-36.44,238.18-60.37,242.97-233.43,395.87-515.64,441.99-783.29H-4.14v882.72c162.34,8.08,336.6-4.03,515.17-39.06Z",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.39-23.83v806.65C826.73,862.84,1031.47,242.36,1089.98-23.83H-3.39Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.02-23.83v810.43c56.13-8.4,112.52-19.98,168.31-34.82,40.57-10.79,80.83-23.31,120.49-37.6,227.56-81.84,439.24-218.7,565.04-437.42,55.18-96,90.93-196.91,115.91-300.59H-7.02Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.46,144.81c211-53.55,395.36-68.93,550.63-63.86,9.55-35.08,17.35-70.05,23.34-104.78H-4.14v594.6C115.3,397.13,307.91,223.13,616.46,144.81Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.91,101.66s-61.45,284.5-348.55,360.23c-287.1,75.73-396.55-34.28-396.55-34.28,0,0-64.93-157.05,36.4-281.26,101.33-124.22,708.7-44.69,708.7-44.69Z",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.46,144.81c165.42-41.99,314.44-60.49,445.92-64.09,11.37-38.47,20.06-73.86,26.81-104.55H-4.14v594.6C115.3,397.13,307.91,223.13,616.46,144.81Z",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.46,144.81c112.03-28.43,216.53-46.09,313.17-55.65,12.51-37.22,23.15-74.92,32.32-112.99H-4.14v594.6C115.3,397.13,307.91,223.13,616.46,144.81Z",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.14,565.7c73.14-101.15,162.34-189.04,264.36-258.48,66.75-45.44,138.6-82.49,213.25-111.66,86.67-33.86,177.37-55.84,268.24-73.57,159.69-31.16,323.11-43.78,485.34-32.3,89.51,6.33,178.62,20.25,265.71,42.74v-31.69c-119.46-30.51-242.45-44.75-365.38-45.97-175.17-1.74-350.01,23.6-519.74,67.8-154.26,40.17-300.58,111.46-425.02,214.86-52.02,43.22-99.8,91.87-142.96,144.56-15.21,18.57-29.79,37.69-43.8,57.26v26.44Z",
    style: {
      fill: "url(#radial-gradient)",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.74-25.05v310.35c35.36-38.39,79.05-78.7,133.06-119.74C411.37-49.49,907.31,45.82,907.31,45.82l-73.97-70.87H-4.74Z",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.84,358.63c3.52,57.81,4.8,108.18,2.55,157.46,86.19-59.48,161.31-124.38,223.23-192.79-116.57-120.64-254.81-160.18-254.81-160.18,0,0,19.35,36.65,29.03,195.51Z",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.7,218.24c-248.08,16.98-447.67,194.16-589.2,387.22,210.47-52.54,413.69-163.74,549.57-336.82,28.83-33.2,39.62-50.41,39.62-50.41Z",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.76,483.57c36.19-3.92,76.36-11.18,120.81-22.91,158.94-41.93,248.73-147.84,297.21-234.03-163.67,32.43-304.04,133.63-418.02,256.94Z",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1492.98,411.35s-383.8,292.55-436.84,634h436.84V411.35Z",
    style: {
      fill: "url(#linear-gradient-18)",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.81,1045.35S963.9,764.18-2.31,734.78v310.57h1494.12Z",
    style: {
      fill: "url(#linear-gradient-19)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.98-25.16S463.36,415.81-2.31,495.46V-25.16h755.29Z",
    style: {
      fill: "url(#linear-gradient-20)",
      mixBlendMode: "multiply",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Livello_2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 1480,
    height: 1000,
    style: {
      fill: "url(#Sfumatura_senza_nome_5)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkgAzzurro);
export default __webpack_public_path__ + "static/media/bkg_azzurro.8138adfa20dab399ee22ae4dadb2a138.svg";
export { ForwardRef as ReactComponent };